<template>
    <div class="sys-input">
        <a-input v-if=" inputType === 'text'" ref="input" v-model.trim="inputValue" :style="{width: width}" @blur="closeInput" />
        <a-input-number v-else-if=" inputType === 'number'" :min="0" ref="input" v-model.trim="inputValue" :style="{width: width}" @blur="closeInput" />
        <div v-else class="input-text" :style="{width: width}" @click="editInput">{{inputValue}}</div>
    </div>
</template>

<script>
export default {
    name: 'YeahagencySysinput',
    props: {
        defaultValue: {},
        width: {
            type: String,
            default: '200px'
        },
        isShowEdit: {
            type: Boolean,
            default: false
        },
        inputType: {
            type: String,
            default: 'text'
        },
        names:{
            type: String,
            default: 'text'
        }
    },
    data() {
        return {
            inputValue: this.defaultValue,
            isEditInput: this.isShowEdit,
        };
    },

    watch: {
        inputValue(val) {
            if (this.inputType === 'number') {
                if (val === 0 || val === '0') {
                    this.inputValue = ''
                }
            }
        }
    },

    created() {
        
    },

    mounted() {
        
    },

    methods: {
        editInput() {
            this.isEditInput = true
            this.$nextTick(() => {
                this.$refs.input.focus()
            })
        },
        closeInput() {
            let dom = this.$refs.input;
            if(!dom.value&&this.names!=='prepriceSysInput'){
                dom.$el.style.border = '1px solid red'
            }else{
                dom.$el.style.border = '1px solid #BFBFBF'
            }
            this.isEditInput = false
            this.$emit('input-change', this.inputValue);
        },
        handelValite() {
            if (!this.inputValue) {
                this.isEditInput = true
                // this.$nextTick(() => {
                //     let dom = this.$refs.input;
                //     dom.$el.scrollIntoView({block: "center", behavior: "smooth",})
                //     // dom.$el.style.borderColor = ''
                // })
            }
        },
        clearInput() {
            this.inputValue = ''
            this.isEditInput = true
        },
    }
};
</script>

<style lang="less" scoped>
    .sys-input {
        .input-text {
            padding-left: 11px;
            width: 200px;
            height: 32px;
            border: 1px solid transparent;
            line-height: 32px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Basic/sysInput.vue